import request from '@/utils/request'

export function getList(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'data/wfdisposecompany/getPageList',
        method: 'POST',
        data: data
    })
}
export function selectByUserId(userName) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: `app/sys/user/infoByUserName/${userName}`,
        method: 'get'
    })
}

export function submit(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'data/wfdisposecompany/postponeApply',
        method: 'POST',
        data: data,
    })
}
// export function submit(data) {
//     return request({
//         baseURL: process.env.VUE_APP_WORKORDER_URL,
//         url: 'app/data/wfdisposepostpone/postponeApply',
//         method: 'POST',
//         data: data,
//     })
// }
export function getInfo(workorderFlowDisposeId) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'app/data/wfdisposecompany/getDetailList/'+workorderFlowDisposeId,
        method: 'POST',
        // data: data,
    })
}
export function getWorkOrderInfo(workorderId) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_API,
        url:  `data/workorder/info/${workorderId}`,
        method: 'POST'
    })
}
export function updateDisposeCompany(data) {
    return request({
        baseURL: process.env.VUE_APP_WORKORDER_URL,
        url: 'data/wfdisposecompany/updateDisposeCompany',
        method: 'POST',
        data: data,
    })
}
